module.exports = __webpack_public_path__ + "static/img/case_banner_01.0f6662f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case_banner_01.png
// module id = siQF
// module chunks = 34